import EtchBlockHeaderStory from './EtchBlockHeaderStory.component';

export default EtchBlockHeaderStory;